// Built-ins
import { useState, useEffect } from "react";

// Icons / Images
import { BiPlus } from "react-icons/bi";
import { BsInfoSquare } from "react-icons/bs";
import { AiOutlineWarning, AiOutlineCheckCircle } from "react-icons/ai";

// Modules / Functions
import axios from "axios";
import Swal from "sweetalert2";
import { Modal, Col, Form, Row, Spinner } from "react-bootstrap";
import { Button } from "semantic-ui-react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

// Global Variables
import { headers } from "../../global_vars";

import {
  AIRCRAFT_PREVIEW_IMAGES,
  aircraftYearSelectOptions,
  defaultAircraftModelYear,
} from "../../data_management/aircraft/aircraft_preview_urls";

// Variables
window.Swal = Swal;

let warningStyle = {
  fontSize: 18,
  marginRight: 6,
};

let checkStyle = {
  fontSize: 18,
  marginRight: 6,
};

const ADD_AIRCRAFT = "https://groupplan.gr/api/view/add_aircraft/";
const GET_CHARTER_BROKERS = "https://groupplan.gr/api/view/get_all_charter_brokers/";

function AddAircraftModal(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [year, setYear] = useState(() => defaultAircraftModelYear());
  const [charterBroker, setCharterBroker] = useState("");
  let [allCharterBrokers, setAllCharterBrokers] = useState([]);
  let [loaded, setLoaded] = useState(false);

  const [selectedAircraft, setSelectedAircraft] = useState("ATR 42");
  const [previewLoadFailed, setPreviewLoadFailed] = useState(false);

  useEffect(() => {
    setPreviewLoadFailed(false);
  }, [selectedAircraft]);

  const aircraftPreviewSrc = AIRCRAFT_PREVIEW_IMAGES[selectedAircraft];
  const aircraftPreviewDisplay =
    previewLoadFailed && selectedAircraft
      ? `https://placehold.co/480x300/2d2d2d/F3702D/png?text=${encodeURIComponent(
          selectedAircraft
        )}`
      : aircraftPreviewSrc;

  const handleChange = (event) => {
    setSelectedAircraft(event.target.value);
  };

  const getCharterBrokers = () => {
    axios
    .get(GET_CHARTER_BROKERS, {
      headers: headers,
    })
    .then((res) => {
      setAllCharterBrokers(
        res.data.all_charter_brokers.map((coop) => coop.name)
      );
      setLoaded(true);
    });
  };

  const createNewAircraft = () => {
    axios({
      method: "post",
      url: ADD_AIRCRAFT,
      headers: headers,
      data: {
        model: selectedAircraft,
        charter_broker: props.charter_broker ? props.charter_broker.name : charterBroker,
        year: Number(year),
      },
    })
      .then((res) => {
        if (props.redir) {
          window.location.href =
            "/data_management/aircraft/" + res.data.new_aircraft_id;
        } else {
          if (props.charter_broker) {
            props.update_state()
          } else {
            props.set_aircraft(
              res.data.new_aircraft_id +
                ") " +
                selectedAircraft +
                "--" +
                charterBroker
            );
          }
        }
      })
      .catch((e) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: e.response.data.errormsg,
        });
      });
  };

  return (
    <>
      <Button
        color="green"
        style={{ margin: 20 }}
        onClick={() => {
          setYear(defaultAircraftModelYear());
          handleShow();
          getCharterBrokers();
        }}
      >
        <BiPlus
          style={{ color: "white", fontSize: "1.3em", marginRight: "0.3em" }}
        />
        Create new Aircraft
      </Button>
      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> Create new Aircraft </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-md-center">
            <Col>
              <Form>
                <Form.Group>
                  <Form.Label>Model:</Form.Label>
                  <select 
                    value={selectedAircraft} 
                    onChange={handleChange}
                    className="form-control"
                    style={{ width: 400, marginLeft: 0, marginTop: 10 }}
                  >
                    {Object.keys(AIRCRAFT_PREVIEW_IMAGES).map((aircraft) => (
                      <option key={aircraft} value={aircraft}>
                        {aircraft}
                      </option>
                    ))}
                  </select>
                  {aircraftPreviewDisplay && (
                    <img
                      src={aircraftPreviewDisplay}
                      alt={selectedAircraft}
                      style={{ width: "300px", margin: 20, height: "auto" }}
                      onError={() => setPreviewLoadFailed(true)}
                    />
                  )}
                  <br/>
                  <Form.Label>Year</Form.Label>
                  <select
                    className="form-control"
                    style={{ width: 400, marginLeft: 0, marginTop: 10 }}
                    value={year}
                    onChange={(e) => {
                      setYear(Number(e.target.value));
                    }}
                  >
                    {aircraftYearSelectOptions().map((y) => (
                      <option key={y} value={y}>
                        {y}
                      </option>
                    ))}
                  </select>
                  <Form.Label style={{ marginTop: 30 }}>
                    Charter Broker
                  </Form.Label>
                  <br />
                  {props.charter_broker ? 
                    <Autocomplete
                      options={allCharterBrokers}
                      className={"select_airport"}
                      disabled
                      value={props.charter_broker.name}
                      style={{ width: 300, margin: 0 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                        />
                      )}
                    />
                  :
                    <>
                      <Autocomplete
                        options={allCharterBrokers}
                        className={"select_airport"}
                        disabled={!loaded}
                        onChange={(e) => {
                          setCharterBroker(e.target.innerText);
                        }}
                        disableClearable
                        value={charterBroker}
                        style={{ width: 300, margin: 0 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Charter Broker"
                            variant="outlined"
                          />
                        )}
                      />
                      {loaded ? (
                        ""
                      ) : (
                        <Spinner
                          animation="border"
                          variant="info"
                          size="sm"
                          style={{
                            position: "fixed",
                            marginTop: 40,
                            marginLeft: 20,
                          }}
                        />
                      )}
                    </>
                  }
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <small className="mr-auto">
            <BsInfoSquare
              style={{
                color: "#F3702D",
                fontSize: "1.5em",
                marginRight: "0.5em",
              }}
            />
            All fields except body number are required to create a aircraft.
            {charterBroker.length === 0 ? (
              <>
                <ul
                  className="mr-auto"
                  style={{ margin: 0, padding: 0, marginTop: 10, color: "red" }}
                >
                  <li>
                    {(!props.charter_broker && charterBroker.length === 0) ? (
                      <>
                        <AiOutlineWarning style={warningStyle} />
                        Fill The Charter Broker Field.
                      </>
                    ) : (
                      ""
                    )}
                  </li>
                </ul>
              </>
            ) : (
              <>
                <ul
                  className="mr-auto"
                  style={{
                    margin: 0,
                    padding: 0,
                    marginTop: 10,
                    color: "green",
                  }}
                >
                  <li>
                    <AiOutlineCheckCircle style={checkStyle} /> Validated
                  </li>
                </ul>
              </>
            )}
          </small>
          <Button color="red" onClick={handleClose}>
            Close
          </Button>
          <Button
            color="green"
            onClick={() => {
              handleClose();
              createNewAircraft();
            }}
            disabled={
              (!props.charter_broker && charterBroker.length === 0)
            }
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddAircraftModal;

